/* =========================================================================
   We Are Clean — estimador de envío del carro
   Cotiza en vivo contra /cart/shipping_rates.json (Blue Express) y muestra
   la fecha de entrega.

   Contrato de DOM (definido en snippets/wac-shipping-estimator.liquid):
     [data-wac-est]     contenedor
     [data-wac-region]  select de región
     [data-wac-comuna]  select de comuna
     [data-wac-result]  donde se pinta el resultado

   Depende de:
     window.WAC_COMUNAS            (assets/comunas-chile.js)
     #wac-diferido  (JSON)         inyectado por el snippet
   ========================================================================= */
(function () {
  'use strict';

  /* Evita ejecutar dos veces si el script se carga desde el snippet
     y tambien desde theme.liquid */
  if (window.__WAC_EST_CARGADO) return;
  window.__WAC_EST_CARGADO = true;

  /* ---------- Parámetros que puedes ajustar ---------- */
  var HORA_CORTE = 12;              // después de esta hora, +1 día hábil
  var DIAS_FABRICACION_DEFAULT = 4; // si el metacampo no trae número

  /* ---------- Días de tránsito de Blue, por región ----------
     Al apagar la promesa de entrega en el portal de Blue, Blue dejó de
     mandar el plazo en la respuesta. Así que el plazo lo definimos acá.
     Si Blue alguna vez vuelve a mandarlo, ese valor manda por sobre
     esta tabla.

     Son días hábiles de TRÁNSITO, sin contar días de preparación. */
  var TRANSITO_POR_REGION = {
    RM: 1,                                                   // Metropolitana
    VS: 2, LI: 2, ML: 2, NB: 2, BI: 2,                       // Priority
    AR: 2, LR: 2, LL: 2, CO: 2, AT: 2,                       // Priority
    AP: 4, TA: 4, AN: 4,                                     // norte extremo
    AI: 10, MA: 10                                           // Aysén y Magallanes
  };
  var TRANSITO_DEFAULT = 4;   // si aparece una región que no está en la tabla

  /* Comunas de la RM que Blue NO alcanza al día hábil siguiente.
     Pega acá los nombres que tengas marcados en la plantilla de Blue.
     Van sin tilde y en mayúscula; el código igual normaliza. */
  var RM_MAS_LENTAS = [
    'ALHUE', 'BUIN', 'CALERA DE TANGO', 'CURACAVI', 'EL MONTE',
    'ISLA DE MAIPO', 'LAMPA', 'MARIA PINTO', 'PADRE HURTADO', 'PAINE',
    'PENAFLOR', 'PIRQUE', 'SAN JOSE DE MAIPO', 'SAN PEDRO', 'TALAGANTE',
    'TILTIL'
  ];
  var RM_MAS_LENTAS_DIAS = 2;

  /* ---------- Envio gratis por etiqueta ----------
     Debe reflejar exactamente lo que hace la Shipping Discount Function
     'envio-gratis-rm' de la app WAC Promesa de Entrega. Si alla cambia la
     etiqueta o la region, hay que cambiarla aca tambien o el carro y el
     checkout van a discrepar. */
  var ETIQUETA_ENVIO_GRATIS = 'envio-gratis-rm';
  var REGIONES_ENVIO_GRATIS = ['RM'];

  /* Feriados de Chile. Mantener sincronizado con despacho-diferido.liquid */
  var FERIADOS = [
    '2026-01-01','2026-04-03','2026-04-04','2026-05-01','2026-05-21',
    '2026-06-22','2026-06-29','2026-07-16','2026-08-15','2026-09-18',
    '2026-09-19','2026-10-12','2026-10-31','2026-11-01','2026-12-08','2026-12-25',
    '2027-01-01','2027-03-26','2027-03-27','2027-05-01','2027-05-21',
    '2027-06-21','2027-06-28','2027-07-16','2027-08-15','2027-09-17',
    '2027-09-18','2027-09-19','2027-10-11','2027-10-31','2027-11-01',
    '2027-12-08','2027-12-25'
  ];

  /* ---------- Fechas y días hábiles ---------- */
  function ahoraChile() {
    var d = new Date();
    try {
      var p = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Santiago',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', hour12: false
      }).formatToParts(d);
      var o = {};
      p.forEach(function (x) { o[x.type] = x.value; });
      return {
        fecha: new Date(+o.year, +o.month - 1, +o.day),
        hora: parseInt(o.hour, 10)
      };
    } catch (e) {
      return { fecha: new Date(d.getFullYear(), d.getMonth(), d.getDate()), hora: d.getHours() };
    }
  }
  function iso(f) {
    return f.getFullYear() + '-' +
           ('0' + (f.getMonth() + 1)).slice(-2) + '-' +
           ('0' + f.getDate()).slice(-2);
  }
  function esHabil(f) {
    var d = f.getDay();
    return d !== 0 && d !== 6 && FERIADOS.indexOf(iso(f)) === -1;
  }
  function sumarHabiles(desde, n) {
    var f = new Date(desde.getTime());
    var sumados = 0;
    var guarda = 0;
    while (sumados < n && guarda < 400) {
      f.setDate(f.getDate() + 1);
      if (esHabil(f)) sumados++;
      guarda++;
    }
    return f;
  }
  function formatoFecha(f) {
    return ('0' + f.getDate()).slice(-2) + '/' +
           ('0' + (f.getMonth() + 1)).slice(-2) + '/' + f.getFullYear();
  }

  /* ---------- Utilidades ---------- */
  function clp(n) {
    return '$' + Math.round(n).toLocaleString('es-CL');
  }
  function normalizar(s) {
    return String(s || '')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .trim().toUpperCase();
  }
  function diasDesdeTexto(txt) {
    // "Hasta 1 día hábil" -> 1 | "Desde 1 Hasta 2 días hábiles" -> 2
    var m = String(txt || '').match(/\d+/g);
    if (!m || !m.length) return null;
    return parseInt(m[m.length - 1], 10);
  }

  /* Días de tránsito para la comuna elegida, según la tabla de arriba */
  function transitoDe(provincia, comuna) {
    var p = normalizar(provincia);
    if (p === 'RM' && comuna) {
      var n = normalizar(comuna.nombre);
      for (var i = 0; i < RM_MAS_LENTAS.length; i++) {
        if (normalizar(RM_MAS_LENTAS[i]) === n) return RM_MAS_LENTAS_DIAS;
      }
    }
    var d = TRANSITO_POR_REGION[p];
    return (typeof d === 'number') ? d : TRANSITO_DEFAULT;
  }

  /* ---------- Etiqueta de envio gratis ----------
     /cart.js no trae las etiquetas del producto, asi que se consultan con
     /products/<handle>.js y se guardan en memoria por handle. */
  var cacheEtiqueta = {};

  function productoTieneEtiqueta(handle) {
    if (Object.prototype.hasOwnProperty.call(cacheEtiqueta, handle)) {
      return Promise.resolve(cacheEtiqueta[handle]);
    }
    return fetch('/products/' + encodeURIComponent(handle) + '.js',
                 { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var buscada = normalizar(ETIQUETA_ENVIO_GRATIS);
        var tiene = false;
        var tags = (p && p.tags) || [];
        for (var i = 0; i < tags.length; i++) {
          if (normalizar(tags[i]) === buscada) { tiene = true; break; }
        }
        cacheEtiqueta[handle] = tiene;
        return tiene;
      })
      .catch(function () { return false; });
  }

  function carroTieneEtiqueta(c) {
    var handles = [];
    var items = (c && c.items) || [];
    for (var i = 0; i < items.length; i++) {
      var h = items[i] && items[i].handle;
      if (h && handles.indexOf(h) === -1) handles.push(h);
    }
    if (!handles.length) return Promise.resolve(false);
    return Promise.all(handles.map(productoTieneEtiqueta))
      .then(function (rs) { return rs.indexOf(true) !== -1; })
      .catch(function () { return false; });
  }

  function aplicaEnvioGratis() {
    return etiquetaEnCarro &&
           REGIONES_ENVIO_GRATIS.indexOf(normalizar(estado.provincia)) !== -1;
  }

  /* ---------- Estado ---------- */
  var estado = {
    regionIdx: null,
    comuna: null,       // { codigo_ine, nombre }
    provincia: null,    // código ISO de Shopify, ej "RM"
    ultimo: null,       // { precio, dias, fecha, servicio, error, cargando }
    pintado: null       // firma de lo último pintado
  };
  var LS = 'wac_envio_v2';

  function guardarPref() {
    try {
      localStorage.setItem(LS, JSON.stringify({
        r: estado.regionIdx,
        c: estado.comuna ? estado.comuna.codigo_ine : null
      }));
    } catch (e) {}
  }
  function leerPref() {
    try { return JSON.parse(localStorage.getItem(LS) || 'null'); } catch (e) { return null; }
  }

  /* ---------- Productos de fabricación en el carro ---------- */
  function diasFabricacion() {
    var el = document.getElementById('wac-diferido');
    if (!el) return 0;
    var mapa;
    try { mapa = JSON.parse(el.textContent || '{}'); } catch (e) { return 0; }
    var max = 0;
    for (var k in mapa) {
      if (!Object.prototype.hasOwnProperty.call(mapa, k)) continue;
      var n = diasDesdeTexto(mapa[k]);
      if (n === null) n = DIAS_FABRICACION_DEFAULT;
      if (n > max) max = n;
    }
    return max;
  }

  /* ---------- Cotización ---------- */
  function cotizar() {
    if (!estado.provincia || !estado.comuna) return Promise.resolve(null);
    var url = '/cart/shipping_rates.json' +
      '?shipping_address%5Bcountry%5D=Chile' +
      '&shipping_address%5Bprovince%5D=' + encodeURIComponent(estado.provincia) +
      '&shipping_address%5Bcity%5D=' + encodeURIComponent(estado.comuna.nombre);

    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (json) {
        var tarifas = (json && json.shipping_rates) || [];
        if (!tarifas.length) return { error: 'sin_tarifa' };

        var mejor = tarifas.reduce(function (a, b) {
          return parseFloat(b.price) < parseFloat(a.price) ? b : a;
        });

        var precio = Math.round(parseFloat(mejor.price));

        /* Si Blue manda el plazo en la descripción lo usamos; si no
           (promesa de entrega apagada en el portal), usamos la tabla. */
        var transito = diasDesdeTexto(mejor.description);
        if (transito === null) transito = transitoDe(estado.provincia, estado.comuna);

        var fab = diasFabricacion();
        var t = ahoraChile();

        var total = null, fecha = null;
        if (transito !== null) {
          total = transito + fab;
          // El corte de las 12:00 solo aplica si no hay fabricación
          if (fab === 0 && t.hora >= HORA_CORTE) total += 1;
          fecha = formatoFecha(sumarHabiles(t.fecha, total));
        }

        return {
          precio: precio,
          gratis: precio === 0,
          dias: total,
          fecha: fecha,
          fabricacion: fab,
          servicio: mejor.name || ''
        };
      })
      .catch(function () { return { error: 'fallo' }; });
  }

  /* ---------- Pintado ---------- */
  function cajas() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-wac-result]'));
  }

  function html(r) {
    if (!r) return '';
    if (r.cargando) {
      return '<div class="wac-est__result"><em>Calculando envío…</em></div>';
    }
    if (r.error === 'sin_tarifa') {
      return '<div class="wac-est__error">No pudimos cotizar el envío para este carro. ' +
             'Escríbenos por WhatsApp y lo vemos.</div>';
    }
    if (r.error) {
      return '<div class="wac-est__error">No pudimos calcular el envío. Intenta de nuevo.</div>';
    }

    var precio = r.gratis ? 'Envío gratis' : clp(r.precio);
    var out = '<div class="wac-est__result' + (r.gratis ? ' wac-est__result--gratis' : '') + '">' +
              '<strong>' + precio + '</strong>';
    if (r.fecha) {
      out += '<small>Llega el ' + r.fecha + ' aprox.';
      if (r.fabricacion > 0) {
        out += ' · incluye ' + r.fabricacion + ' días hábiles de preparación';
      }
      out += '</small>';
    }
    out += '</div>';
    return out;
  }

  function pintar() {
    var marca = html(estado.ultimo);
    cajas().forEach(function (c) {
      if (c.innerHTML !== marca) c.innerHTML = marca;
    });
    pintarTotales();
  }

  /* Líneas de Envío y Total con envío en el resumen del carro */
  function pintarTotales() {
    var r = estado.ultimo;
    var anclas = Array.prototype.slice.call(document.querySelectorAll('.cart__total-container'));
    anclas.forEach(function (ancla) {
      var bloque = ancla.parentNode.querySelector('.wac-injected-wrap');
      if (!r || r.error || r.cargando || r.precio == null) {
        if (bloque) bloque.remove();
        return;
      }
      if (!bloque) {
        bloque = document.createElement('div');
        bloque.className = 'wac-injected-wrap';
        ancla.parentNode.insertBefore(bloque, ancla.nextSibling);
      }
      var sub = subtotalCarro();
      var marca =
        '<div class="wac-injected wac-injected-envio">' +
          '<span>Envío a ' + (estado.comuna ? estado.comuna.nombre : '') + '</span>' +
          '<strong>' + (r.gratis ? 'Gratis' : clp(r.precio)) + '</strong>' +
        '</div>' +
        (sub == null ? '' :
        '<div class="wac-injected wac-injected-total">' +
          '<span>Total con envío</span>' +
          '<strong>' + clp(sub + r.precio) + '</strong>' +
        '</div>');
      if (bloque.innerHTML !== marca) bloque.innerHTML = marca;
    });
  }

  var subtotalCache = null;
  function subtotalCarro() { return subtotalCache; }

  /* ---------- Selects ---------- */
  function regiones() {
    return window.WAC_COMUNAS || [];
  }
  function llenarRegiones(sel) {
    if (sel.dataset.wacLleno === '1') return;
    var regs = regiones();
    var frag = document.createDocumentFragment();
    regs.forEach(function (r, i) {
      var o = document.createElement('option');
      o.value = String(i);
      o.textContent = r.nombre;
      frag.appendChild(o);
    });
    sel.appendChild(frag);
    sel.dataset.wacLleno = '1';
  }
  function llenarComunas(sel, idx) {
    while (sel.options.length > 1) sel.remove(1);
    var r = regiones()[idx];
    if (!r) { sel.disabled = true; return; }
    var frag = document.createDocumentFragment();
    r.comunas.slice().sort(function (a, b) {
      return a.nombre.localeCompare(b.nombre, 'es');
    }).forEach(function (c) {
      var o = document.createElement('option');
      o.value = c.codigo_ine;
      o.textContent = c.nombre;
      frag.appendChild(o);
    });
    sel.appendChild(frag);
    sel.disabled = false;
  }
  function provinciaDe(idx) {
    var r = regiones()[idx];
    if (!r || !r.codigo_iso) return null;
    return String(r.codigo_iso).split('-').pop();
  }

  /* ---------- Atributos del carro ---------- */
  var attrsGuardados = null;
  function guardarAttrs() {
    if (!estado.comuna || !estado.ultimo || estado.ultimo.error) return;
    var attrs = {
      'Región': regiones()[estado.regionIdx] ? regiones()[estado.regionIdx].nombre : '',
      'Comuna': estado.comuna.nombre,
      'Código INE': estado.comuna.codigo_ine,
      '_promesa_entrega': estado.ultimo.fecha || ''
    };
    var firma = JSON.stringify(attrs);
    if (firma === attrsGuardados) return;
    attrsGuardados = firma;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  /* ---------- Ciclo de cálculo ---------- */
  var secuencia = 0;
  var firmaPintada = null;
  var etiquetaEnCarro = false;

  function firmaCarro(c) {
    return Math.round((c.total_price || 0) / 100) + '|' +
           Math.round(c.total_weight || 0) + '|' + (c.item_count || 0);
  }

  function marcarCargando() {
    if (!estado.comuna) return;
    estado.ultimo = { cargando: true };
    pintar();
  }

  function estimar() {
    if (!estado.comuna || !estado.provincia) return;
    var mia = ++secuencia;
    var firma = null;

    var pCarro = fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        subtotalCache = Math.round((c.total_price || 0) / 100);
        firma = firmaCarro(c);
        if (firma !== firmaPintada || !estado.ultimo || estado.ultimo.error) marcarCargando();
        return carroTieneEtiqueta(c).then(function (x) { etiquetaEnCarro = x; });
      })
      .catch(function () {});

    var pTarifa = cotizar();

    Promise.all([pCarro, pTarifa]).then(function (res) {
      if (mia !== secuencia) return;
      firmaPintada = firma;
      var r = res[1];
      /* El descuento de envio se calcula en el checkout, no en
         /cart/shipping_rates.json. Lo reproducimos aca para que el carro
         y el checkout no digan cosas distintas. */
      if (r && !r.error && !r.cargando && aplicaEnvioGratis()) {
        r.precio = 0;
        r.gratis = true;
      }
      estado.ultimo = r;
      pintar();
      guardarAttrs();
    });
  }

  /* ---------- Enganches ---------- */
  function enganchar(raiz) {
    var est = raiz.querySelector ? raiz.querySelector('[data-wac-est]') : null;
    if (!est) return;

    var selR = est.querySelector('[data-wac-region]');
    var selC = est.querySelector('[data-wac-comuna]');
    if (!selR || !selC) return;
    if (est.dataset.wacListo === '1') return;
    est.dataset.wacListo = '1';

    llenarRegiones(selR);

    selR.addEventListener('change', function () {
      var idx = selR.value === '' ? null : parseInt(selR.value, 10);
      estado.regionIdx = idx;
      estado.provincia = idx === null ? null : provinciaDe(idx);
      estado.comuna = null;
      estado.ultimo = null;
      llenarComunas(selC, idx);
      pintar();
      guardarPref();
    });

    selC.addEventListener('change', function () {
      var r = regiones()[estado.regionIdx];
      if (!r) return;
      var c = null;
      for (var i = 0; i < r.comunas.length; i++) {
        if (r.comunas[i].codigo_ine === selC.value) { c = r.comunas[i]; break; }
      }
      estado.comuna = c;
      guardarPref();
      if (c) estimar(); else { estado.ultimo = null; pintar(); }
    });

    // Restaurar preferencia
    var pref = leerPref();
    if (pref && pref.r !== null && pref.r !== undefined) {
      selR.value = String(pref.r);
      estado.regionIdx = pref.r;
      estado.provincia = provinciaDe(pref.r);
      llenarComunas(selC, pref.r);
      if (pref.c) {
        selC.value = pref.c;
        var rr = regiones()[pref.r];
        if (rr) {
          for (var j = 0; j < rr.comunas.length; j++) {
            if (rr.comunas[j].codigo_ine === pref.c) { estado.comuna = rr.comunas[j]; break; }
          }
        }
      }
    }

    if (estado.ultimo) pintar();
    if (estado.comuna) estimar();
  }

  function escanear() {
    document.querySelectorAll('[data-wac-est]').forEach(function (el) {
      enganchar(el.parentNode || document);
    });
  }

  /* Horizon vuelve a renderizar el carro y borra lo pintado: repintamos
     de forma sincrónica dentro del observer para que no haya parpadeo. */
  var mo = new MutationObserver(function () {
    if (estado.ultimo) {
      var vacio = Array.prototype.some.call(
        document.querySelectorAll('[data-wac-result]'),
        function (c) { return !c.innerHTML; }
      );
      if (vacio) pintar();
    }
    escanear();
  });

  function onCarroCambia() {
    if (!estado.comuna) return;
    estimar();
    setTimeout(estimar, 1200); // segunda pasada: /cart.js a veces viene atrasado
  }

  function iniciar() {
    escanear();
    mo.observe(document.body, { childList: true, subtree: true });
    [
      'cart:update', 'cart:updated', 'cart:refresh', 'cart:change',
      'cart-update', 'theme:cart:update', 'theme:cart:change'
    ].forEach(function (ev) {
      document.addEventListener(ev, onCarroCambia);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();